<template>
    <div class="ota-admin-users-page">
      <base-header class="pb-6 bg-light">
        <b-row align-v="center" class="py-4">
          <b-col cols="12" lg="6">
            <h6 class="h2 d-inline-block mb-0 text-dark">Users</h6> &nbsp;
          </b-col>
          <b-col cols="12" lg="6" class="text-right">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </b-col>
        </b-row>

        <div v-if="noAccess">
          <b-card>
            <b-card-header>
              <p class="h2 mb-2">
                <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill>&nbsp;Restricted
              </p>
            </b-card-header>
            <b-card-body>Access is Restricted</b-card-body>
          </b-card>
        </div>

        <div v-else>
          <!-- START: LIST_USERS -->

          <div class="accordion border-black-2" role="tablist" >

            <!-- Name Table for Carriers Card -->
            <b-card no-body class="mb-0 border-non-radius">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block variant="primary" class="border-non-radius text-left d-flex justify-content-between align-items-center py-1">
                  <div>User Name</div>
                  <div>Carrier</div>
                  <base-button type="warning" class="vertical-dot-button p-1" @click="reloadUserList">
                    <!-- @click="getCarrierList_API">-->
                    <i class="fa fa-recycle"></i>
                  </base-button>
                </b-button>
              </b-card-header>
            </b-card>
            <b-card v-if="userLoading" id="lists_carrier_card">
              <b-row class="text-md-center">
                <b-col md="12">
                  <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
                </b-col>
              </b-row>
            </b-card>
            <div v-else>

              
              <!-- START: NEW_USER -->
            <b-card no-body class="mb-0 border-non-radius" id="new_ota_user_card">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <base-button
                    block
                    type="light"
                    v-b-toggle.accordion-ota-user-2
                    class="border-non-radius text-left"
                    @click="newUserClick = !newUserClick"
                >
                  <i class="fas  mr-1" v-bind:class="newUserClick ? 'fa-angle-down' : ' fa-angle-right'"></i>+
                    New User
                </base-button>
              </b-card-header>
              <b-collapse id="accordion-ota-user-2" accordion="my-accordion-ota-user-2" role="tabpanel">
                <b-card-body>
                  <!-- GENERAL -->
                  <b-row class="mb-3">
                    <b-col lg="6">
                      <b-button variant="primary" size="sm" class="text-white w-100 text-left">General</b-button>
                      <b-row class="mt-3">
                        <b-col lg="3">
                          <label for="parent" class="mt-1">Parent</label>
                        </b-col>
                        <b-col lg="9">
                          <b-form-select
                              size="sm"
                              v-model="newUser.parent"
                              @change="(e) => handleChangeParent(e)"
                              :options="newUser.parents">
                          </b-form-select>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col lg="3">
                          <label for="name" class="mt-1">Carrier</label>
                        </b-col>
                        <b-col lg="9">
                          <b-form-select
                              size="sm"
                              @change="(e) => handleCarrierSelect(e)"
                              :value="newUser.carrier"
                              :options="carriers">
                          </b-form-select>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2 user-name-field-prefix">
                        <b-col lg="3">
                          <label for="name" class="mt-1">User Name</label>
                        </b-col>
                        <b-col lg="9">
                          <b-input-group class="mb-3">
                            <b-input-group-append>
                              <b-input-group-text class="bg-transparent " >
                                {{newUser.userName && newUser.userName+'.'}}
                              </b-input-group-text>
                            </b-input-group-append>
                            <b-form-input
                                size="sm"
                                v-model="newUser.user_name"
                                class="usernameStyleAppend"
                                :state="usernameStatus"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="!usernameStatus">
                              Please enter a valid username
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col lg="6">
                      <b-button variant="primary" size="sm" class="text-white w-100 text-left">
                        Password
                      </b-button>

                      <b-row class="mt-2">
                        <b-col lg="12">
                          Must be at least 10 characters and contain an upper-case letter, lower-case letter, number and a special character (!@#$%^&*)
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col lg="6">
                          <span v-if="!!newUser.generatedPassword" class="text-info font-weight-bold">{{newUser.generatedPassword}}</span>
                          <b-icon v-if="!!newUser.generatedPassword" v-on:click="copyToClipboard('copyPass')" icon="files" class="font-16 cursor-pointer ml-2 text-black-50 mr-2"></b-icon>
                        </b-col>
                        <b-col lg="6">
                          <div class="text-right ml-3">
                            <b-button @click="generatePassword('new')" variant="primary" size="sm" class="text-white ">
                              Generate
                            </b-button>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col lg="3">
                          <label for="password" class="mt-1">New Password</label>
                        </b-col>
                        <b-col lg="9">
                          <b-form-input
                              size="sm"
                              type="password"
                              v-model="newUser.password"
                              :state="passwordStatus"
                              placeholder="Enter your password"
                          ></b-form-input>
                          <!-- <b-form-invalid-feedback v-if="!passwordLength">
                            Your password must have at least 10 chars.
                          </b-form-invalid-feedback>
                          <b-form-invalid-feedback v-if="!passwordUppercase">
                            Your password must have at least 1 upper case letter.
                          </b-form-invalid-feedback>
                          <b-form-invalid-feedback v-if="!passwordNumber">
                            Your password must have at least 1 number.
                          </b-form-invalid-feedback>
                          <b-form-invalid-feedback v-if="!passwordCharacter">
                            Your password must have at least 1 special char.
                          </b-form-invalid-feedback> -->
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col lg="3">
                          <label for="repeat_password" class="mt-1">Repeat</label>
                        </b-col>
                        <b-col lg="9">
                          <b-form-input
                              size="sm"
                              type="password"
                              v-model="newUser.repeat_password"
                              placeholder="Repeat your password"
                              :state="repeatPasswordCheck"
                          ></b-form-input>
                          <!-- <b-form-invalid-feedback v-if="!repeatPasswordCheck">
                            Please input valid password
                          </b-form-invalid-feedback> -->
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <!-- Permissions -->
                  <b-row>
                    <b-col lg="12">
                      <b-button
                        block
                        v-b-toggle.accordion-5
                        size="sm"
                        class="border-non-radius text-white text-left mb-2"
                        variant="primary"
                      >
                        User Permission
                      </b-button>
                      <b-row class="ml-0">
                        <b-col lg="2" v-for="(value, key) in newUser.user_flags" :key="key">
                          <b-form-checkbox
                              size="sm"
                              :id="value.label"
                              :name="value.label"
                              v-model="newUser.flags[key]"
                          >
                            {{value.label}}
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <b-row class="mt-2">
                    <b-col cols="9"></b-col>
                    <b-col cols="3">
                      <b-button size="sm" variant="primary" class="w-100 text-center text-white"
                                @click="createNewUserProfile">Add
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card v-if="existingUsers.users === null" id="lists_carrier_card">
              <b-row class="text-md-center">
                <b-col md="12">
                  <b-icon icon="three-dots" animation="cylon" font-scale="4"></b-icon>
                </b-col>
              </b-row>
            </b-card>
            <!-- END: NEW_USER -->

            
          <!-- START: EXISTING_USERS -->
          <b-card no-body v-else class="mb-0 border-non-radius" v-for="(user, index) in existingUsers.users" :key="index">
            <b-card-header header-tag="header" class="p-0 d-flex justify-content-between align-items-center" role="tab" >
              <base-button
                  block
                  type="light"
                  v-b-toggle="'accordion-3'+index"
                  class="border-non-radius user-root-accordion d-flex text-dark text-left w-100"
                  v-on:click="user.clickUser = !user.clickUser"
                  :disabled="user.disabled === 1"
              >
              <b-row class="w-100">
                <b-col cols="10" md="11" class="d-flex">
                  <div class="w-50 nowrap">
                    <span v-if="user.disabled !== 1">
                      <i class="fas  mr-1 fa-angle-down"></i>
                      <i class="fas  mr-1 fa-angle-right ml-0"></i>
                    </span>
                    {{user.username}}
                  </div>
                  <div class="text-left">
                    {{user.carrier.display_name}}
                  </div>
                </b-col>
                <b-col cols="2" md="1" class="text-right pr-0">
                  <b-button class="vertical-dot-button" variant="primary" :id="user.username +'popover'" >
                    <b-icon icon="three-dots-vertical" class="font-16"></b-icon> 
                  </b-button>
                  
                    <b-popover :target="user.username+'popover'" triggers="hover" placement="topleft">
                      <b-row>
                        <base-button
                              type="link"
                              v-on:click="disableUser_API({username:user.username, disable: !!user.disabled ? 0 : 1})">
                              {{user.disabled !== 1 ? "Disable" : "Enable"}}
                        </base-button>
                      </b-row>
                      <b-row >
                        <base-button
                              v-if="user.can_remove === 1"
                              type="link"
                              v-on:click="deleteUser_API(user.username)">
                              Remove
                        </base-button>
                      </b-row>
                    </b-popover>
                </b-col>
              </b-row>
            </base-button>
            </b-card-header>
            <b-collapse :id="'accordion-3'+index" accordion="my-accordion3" role="tabpanel">
              <b-card-body>
                <!-- GENERAL -->
                <b-row class="mb-3">
                  <b-col lg="6">
                    <b-button variant="primary" size="sm" class="text-white w-100 text-left">General</b-button>
                    <b-row class="mt-3">
                      <b-col lg="3">
                        <label for="parent" class="mt-1">Parent</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-select
                            size="sm"
                            disabled
                            v-model="user.parent"
                            :options="user.parents">
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="3">
                        <label for="name" class="mt-1">Carrier</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-select
                            size="sm"
                            disabled
                            v-model="user.carrier.name"
                            :options="existingUsers.carriers">
                        </b-form-select>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2 mb-3">
                      <b-col lg="3">
                        <label for="name" class="mt-1">User Name</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-input
                            size="sm"
                            disabled
                            v-model="user.username"
                            placeholder="Enter your name"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col lg="6">
                    <base-button type="primary" size="sm" class="text-white w-100 text-left">
                      Password
                    </base-button>

                    <b-row class="mt-2">
                      <b-col lg="12">
                        Must be at least 10 characters and contain an upper-case letter, lower-case letter, number and a special character (!@#$%^&*)
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="8">
                        <span v-if="!!user.generatedPassword" class="text-info font-weight-bold">{{user.generatedPassword}}</span>
                        <b-icon v-if="!!user.generatedPassword" @click="copyToClipboard('copyPass', user.password)" icon="file-earmark" class="font-16 cursor-pointer ml-2 text-black-50 mr-2"></b-icon>
                      </b-col>
                      <b-col lg="4">
                        <div class="text-right ml-3">
                          <b-button v-on:click="existingUserGenerate(user.username)" variant="primary" size="sm" class="text-white ">
                            Generate
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="3">
                        <label for="password" class="mt-1">Password</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-input
                            size="sm"
                            type="password"
                            v-model="user.password"
                            placeholder="Enter your password"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col lg="3">
                        <label for="repeat" class="mt-1">Repeat</label>
                      </b-col>
                      <b-col lg="9">
                        <b-form-input
                            size="sm"
                            type="password"
                            v-model="user.repeat"
                            placeholder="Repeat your password"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Permission -->
                <b-row>
                  <b-col lg="12">
                    <b-button
                      block
                      size="sm"
                      class="border-non-radius text-white text-left mb-2"
                      variant="primary"
                    >
                      User Permission
                    </b-button>
                    <b-row class="ml-0" >
                      <b-col lg="2" md="6" v-for="(value, key) in existingUsers.user_flags" :key="key">
                        <b-form-checkbox v-if="user.can_remove === 1"
                            size="sm"
                            :id="key+user.username"
                            :name="key+user.username"
                            v-model="user.flags[key]"
                        >
                          {{value.label}}
                        </b-form-checkbox>
                        <b-form-checkbox v-else
                            size="sm"
                            :id="value.label"
                            :name="value.label"
                            disabled
                            v-model="user.flags[key]"
                        >
                          {{value.label}}
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row class="mt-4">
                  <b-col lg="12">
                    <b-button
                        block
                        v-b-toggle="'accordion-99'+index"
                        class="border-non-radius api-token-accordion text-white py-1 text-left"
                        v-on:click="user.apiTokenClick = !user.apiTokenClick"
                        variant="primary"
                    >
                      <i class="fas  fa-angle-down mr-1"></i>
                      <i class="fas fa-angle-right  mr-1"></i>
                        API Tokens
                    </b-button>
                    <b-collapse :id="'accordion-99'+index" class="users-api-token" accordion="my-accordion5" role="tabpanel">
                      <b-button
                        block
                        class="border-non-radius text-white d-flex py-1 text-left mt-2"
                        variant="info"
                      >
                        <div class="ip">
                          IP Address
                        </div>
                        <div class="token">
                          Token
                        </div>
                        <div></div>
                      </b-button>
                      <div v-if="user.tokens" class="ipAddressStyle">
                        <div  class="d-flex ml-3 mt-2" v-for="(token, key) in user.tokens" :key="key">
                          <div class="ip">
                            {{token.ip || "-"}}
                          </div>
                          <div v-bind:class="token.revoked ? 'disable' : 'enable' " class="token d-flex" @click="copyToClipboard">
                            {{token.token}}
                            <b-icon v-if="!token.revoked" @click="copyToClipboard('copyToken', token.token)" icon="files" class="font-16 cursor-pointer ml-2 text-black-50 mr-2"></b-icon>
                          </div>
                          <div class='revoked'>
                            <base-button :disabled="token.revoked" @click="revokeUserToken(token.token)" class="px-3" size="sm" :type="token.revoked? 'default': 'warning'">
                              {{token.revoked ? 'Revoked' : 'Revoke'}}
                            </base-button>
                          </div>
                        </div>
                      </div>
                      
                      <div class="d-flex create-token justify-content-between align-items-center mt-2">
                          <b-input-group >
                          <b-form-input
                          class="flex-0 flex-grow-0"
                          size="sm"
                          v-model="user.ip"
                          placeholder="Enter your IP"
                          :state="validateIPaddress(user.ip)"
                        ></b-form-input>
                        <b-form-invalid-feedback v-if="!validateIPaddress(user.ip)">
                            Please input valid IP Address
                        </b-form-invalid-feedback>
                        </b-input-group >
                          <base-button @click="createUserToken(user.ip, user.username)" size="sm" class="py-1 px-3" type="primary">
                            Create
                          </base-button>
                      </div>
                    </b-collapse>
                  </b-col>
                </b-row>

                <b-row class="mt-2">
                  <b-col cols="9"></b-col>
                  <b-col cols="3">
                    <b-button size="sm" variant="primary" class="w-100 text-center text-white"
                              @click="modifyUserProfile(user.username)">Save
                    </b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
          <!-- END: EXISTING_CARRIERS -->
            </div>
          </div>
        </div>
  
        
      </base-header>
    </div>
  </template>
  
  <script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import otaDashboardService from "@/common/api-services/ota-dashboard-service";
  import initService from "@/common/api-services/init-service";
  import swal from "sweetalert2";
  export default {
    components: {
      RouteBreadCrumb
    },
    name: "otaUsers",
  
    data() {
      return {
        copied: false,
        userLoading: false,
        dirty: [],
        carriers: [],
        localCarrier: null,
        flag_items: {},
        newUser: {
          userName: "",
          parents: [{text: "None", value: "none"}],
          parent: "",
          carrier: "",
          user_name: "",
          generatedPassword: null,
          password: "",
          repeat_password: "",
          user_flags: {},
          flags: {},
        },

        existingUsers: {
          users: [],
          carriers: [],
          user_flags: {}
        },

        newUserClick: false,

        ///https://ota.dccllc.net/ota/api/user/check and res.user.carrier.name [display_name]
        newParentOption: [{value: "none", text: "None"}],

  

        //ACCESS ROLES
        isReadOnly: true,
        isEditor: false,
        isAdministrator: false,
        isPortalAdmin: false,
        isOtaAdmin: false,
        usernameInputClickStatus: false,
      };
    },
  
    mounted: function () {
      document.title = 'OTA - Users Admin';
      /** NOTE: The following needs to be in data:
       noAccess: true,
       isReadOnly: true,
       isEditor: false,
       isAdministrator: false,
       isPortalAdmin: false,
       */

      // set the roles [isReadOnly, isEditor, isAdministrator, isPortalAdmin]
      this.isReadOnly = (initService.getUserRoles().includes('OTA_READ'));
      this.isEditor = (initService.getUserRoles().includes('OTA_READ'));
      this.isAdministrator = (
        initService.getUserRoles().includes('PORTAL_ADMIN') || 
        initService.getUserRoles().includes('CARRIER_ADMIN') || 
        initService.getUserRoles().includes('OTA_ADMIN') 
        );
      this.isPortalAdmin = (initService.getPortalAdminRole());
      this.isAdministrator = initService.getUserRoles().includes('CARRIER_ADMIN');
      this.isOtaAdmin = initService.getUserRoles().includes('OTA_ADMIN');
  
      //write to console
      //don't do anything unless the user has access
      if (!this.noAccess) {
        this.getUsersList_API();
        this.getCarriersList_API();
      } else {
        this.$router.push("/restricted").catch(() => {});
      }
  
    },  
    methods: {

      // Create user token
      createUserToken(ip, username) {
        if (this.validateIPaddress(ip)) {
          const payload = {
          ip: ip,
          username: username
        }
        otaDashboardService.createToken(payload).then(async (res) => {
          if(res  && res.data.status) {
            this.getUsersList_API();
          } else {
            this.$toast.error(res.data.error_string)
          }
        })
        .catch(err => {
          console.log(err)
        })
        }
      },

      // Revoke user token
      revokeUserToken(token) {
        swal.fire({
          title: `Revoke API token`,
          text: `This will completely disable access to the API token, are you sure you want to continue?  This action is irreversible.`,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: "Ok",
          cancelButtonText: "Cancel",
          customClass: {
						cancelButton: 'order-1 mr-3',
						confirmButton: 'btn btn-danger order-2',
					},
        }).then(result => {
          if (result.isConfirmed) {
            const payload = {
              token: token 
            }
            otaDashboardService.revokeToken(payload).then(async (res) => {
              if(res) {
                this.getUsersList_API();
              } 
            })
            .catch(err => {
              console.log(err)
            })
          }
        });
        
      },
      
      generatePassword(type = "ex") {
        var lettersSetArray = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
        var symbolsSetArray = [ "=","+","-","^","?","!","%","&","*","$","#","^","@","|"];
        var passwordArray = [];
        var digitsPositionArray = [];
        // first, fill the password array with letters, uppercase and lowecase
        for (var i = 0; i < 15; i++) {
          // get an array for all indexes of the password array
          digitsPositionArray.push(i);
          var upperCase = Math.round(Math.random() * 1);
          if (upperCase === 0) {
            passwordArray[i] = lettersSetArray[Math.floor(Math.random()*lettersSetArray.length)].toUpperCase();
          }
          else {
            passwordArray[i] = lettersSetArray[Math.floor(Math.random()*lettersSetArray.length)];
          }
        }
        // Add digits to password
        for (i = 0; i < 5; i++) {
          let digit = Math.round(Math.random() * 9);
          let numberIndex = digitsPositionArray[Math.floor(Math.random()*digitsPositionArray.length)];
          passwordArray[numberIndex] =  digit;
          var j = digitsPositionArray.indexOf(numberIndex);
          if(i != -1) {
            digitsPositionArray.splice(j, 1);
          }
        }
        // add special charachters "symbols"
        for (i = 0; i < 5; i++) {
          var symbol = symbolsSetArray[Math.floor(Math.random()*symbolsSetArray.length)];
          var symbolIndex = digitsPositionArray[Math.floor(Math.random()*digitsPositionArray.length)];
          passwordArray[symbolIndex] =  symbol;
          var j = digitsPositionArray.indexOf(symbolIndex);
          if(i != -1) {
            digitsPositionArray.splice(j, 1);
          }
        }
        if(type === "new") {
          this.newUser.password = passwordArray.join("");
          this.newUser.repeat_password = this.newUser.password;
          this.newUser.generatedPassword = this.newUser.password;
        }

        return passwordArray.join("");
      },
      // Copy password
      copyToClipboard(type = "copy", token = "no-token"){
        var copyElement = document.createElement("textarea");
        copyElement.style.opacity = '0';
        copyElement.style.position = 'fixed';
        copyElement.textContent = type === "copyToken" || type === "copyPass" ? token : this.newUser.password;
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(copyElement);
        copyElement.select();
        document.execCommand('copy');
        body.removeChild(copyElement);
        
        if(type === "copyToken" || type === "copyPass") {
          this.$toast.info(`${type !== "copyToken" ? "Password" : "Token"} copied successfully!`)
        } else {
          this.copied = true;
          // reset this.copied
          setTimeout(() => {
            this.copied = false;
          }, 1000);
        }
      },

      existingUserGenerate(user_name) {
        const generate = this.generatePassword();
        const user = this.existingUsers.users.find(({username}) => username === user_name);
        console.log(this.existingUsers, 'this existing users')
        user.generatedPassword = generate;
        user.password = generate;
        user.repeat = generate;
        user.copied = true;
      },
  
      getCarriersList_API() {
        // console.log('getCarrierList_API fired');
        const data = JSON.stringify({add: 1, flag_labels: 1});
        otaDashboardService
          .getCarriersList(data)
          .then(res => {
            res.data.result.carriers.map(carrier => {
              if (carrier.hasOwnProperty("display_name") && carrier.display_name !== "") {
                this.carriers.push({value: JSON.stringify({name: carrier.name, primary_user: carrier.primary_user}), text: carrier.display_name});
              }
            });
            // this.setCarrierData(res.data.result.carriers);
            // this.efOptions = Object.entries(res.data.result.files).map(e => e[0]);
          })
          .catch(err => {
            throw err;
          });
    },

    // Get users list
    async getUsersList_API() {
      this.userLoading = true;
      this.newUserClick = false;
      const data = JSON.stringify({add: 1, flag_labels: 1});
      await otaDashboardService
        .getUsersList(data)
        .then(async (res) => {
          this.existingUsers.user_flags = res.data.result.user_flags;
          // console.log(this.existingUsers, 'this. existing users')
          this.newUser.user_flags = res.data.result.user_flags;
          const users = res.data.result.users;
          this.newUser.parents = [{text: "None", value: "none"}];

          if(users.length > 0) {
            this.existingUsers.users = []
          }

          await users.map((user) => {
            let tokens = [];
            if(user.hasOwnProperty("tokens")) {
              Object.entries(user.tokens).forEach(([key, value]) => {
                let item = {
                  token: key,
                  ip: value.ip,
                  revoked: value.revoked,
                  created: value.created,
                  lastused: value.lastused
                };
                tokens.push(item)
              })
            }

            const other = {
              password: "",
              generatedPassword: "",
              clickUser: false,
              copied: false,
              repeat: "",
              apiTokenClick: false
            }
          
            const parent = [
              {
                text: "None",
                value: "none"
              }
            ];

            const value = {
              carrier: user.carrier.name,
              name: user.username,
              userName: user.carrier.primary_user
            }
            
            if(!user.hasOwnProperty('add')) {
              let flagsItem = user.flags;
              Object.entries(user.flags).map(([key, value]) => {
                return flagsItem[key] = !!value
              });

              this.newUser.parents.push({text: user.username, value: JSON.stringify(value)});
              this.existingUsers.users.push({...user, parents: [...parent, {value: user.parents[0], text: user.parents[0]}], parent: user.parents[0] || 'none', flags: {...flagsItem}, tokens: [...tokens], ...other})
            } else if (user.hasOwnProperty("add")) {
              this.newUser.flags = user.flags;
              Object.entries(user.flags).map(([key, value]) => {
                return this.newUser.flags[key] = !!value;
              });
            }
        
          })
          res.data.result.carriers.map((carrier) => {
            if (carrier.hasOwnProperty("display_name") && carrier.display_name !== "") {
                this.existingUsers.carriers.push({value: carrier.name, text: carrier.display_name});
              }
          })
          this.userLoading = false;
        })
        .catch(err => {
          this.userLoading = false;
          throw err;
          
        });

        this.userLoading = false;
      },
      /** API METHODS **/

      modifyUserProfile(userName) {
        const findUser = this.existingUsers.users.find(({username}) => username === userName);
        console.log("SUERNAME", userName)
        if(findUser) {
          const payload = {
            parent: findUser.parent,
            carrier: findUser.carrier.name,
            username: findUser.username,
            flags: {
              ...findUser.flags
            },
            type: "users",
            method: "modify"
          };
          if(findUser.password !== "" && findUser.repeat !== "") {
            payload['password'] = findUser.password;
            payload['repeat'] = findUser.repeat;
          }

          otaDashboardService.modifyUser(payload).then((res) => {
            if(res && res.data.status) {
              this.getUsersList_API();
            } else {
              this.$toast.error(res.data.error_string)
            }
          })
          .catch((err) => console.log(err))
          
        }
      },

      async createNewUserProfile() {
        const user = this.newUser;
        let carrierName = '';
        let parentName = '';
        if(user.carrier !== "") {
          carrierName = JSON.parse(user.carrier).name;
        }
        if(user.parent !== "") {
          parentName = JSON.parse(user.parent).name;
        }
        if(this.usernameStatus && this.passwordStatus && this.repeatPasswordCheck) {
          const payload = {
            parent: parentName,
            carrier: carrierName,
            username: user.userName ? user.userName+'.'+user.user_name : user.user_name,
            password: user.password,
            repeat: user.repeat_password,
            flags: {
              ...user.flags
            },
            type: "users",
            method: "add"
          };

          await otaDashboardService
          .createNewUser(payload)
          .then((res) => {
            if(res && res.data.status) {
              this.getUsersList_API();
              this.newUserClick = false
              this.$toast.success('Successfully created');
              this.newUser = {
                userName: "",
                parents: [{text: "None", value: "none"}],
                parent: "",
                carrier: "",
                user_name: "",
                generatedPassword: null,
                password: "",
                repeat_password: "",
                user_flags: {},
                flags: {},
              }
            } else {
              this.$toast.error(res.data.error_string);
            }
          })
          .catch((err) => console.log(err))
        }
      },

      handleCarrierSelect(e) {
        const primary = JSON.parse(e).primary_user;
        if(typeof primary !== 'null') {
          this.newUser.userName = primary;
        }
      },
      handleChangeParent(e) {
        if(e && e !== 'none') {
          console.log('here')
          const val = JSON.parse(e);
          const carrier = this.carriers.find(({value}) => JSON.parse(value).name === val.carrier);
          this.newUser.carrier = carrier.value;
          this.newUser.userName = JSON.parse(carrier.value).primary_user+'';
        } else {
          this.newUser.carrier = this.carriers[0].value
        }
      },

      deleteUser_API(name) {
        swal.fire({
          title: `Remove user`,
          text: `This will remove the user '${name}' including any active tokens. This action is irreversible. Do you want to continue?`,
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: "Ok",
          cancelButtonText: "Cancel",
          customClass: {
						cancelButton: 'order-1 mr-3',
						confirmButton: 'btn btn-danger order-2',
					},
        }).then(result => {
          if (result.isConfirmed) {
            const payload = {
              username: name 
            }
            otaDashboardService.removeUser(payload).then(async (res) => {
              if(res && res.data.status) {
                this.getUsersList_API();
              } else {
                this.$toast.error(res.data.error_string)
              }
            })
            .catch(err => {
              console.log(err)
            })
          }
        });
      },

      disableUser_API(data) {
        console.log(data)
        if (data.disable === 1) {
          swal.fire({
              title: `Disable user`,
              text: `This will disable the user '${data.username}' and any logins associated with it. Do you want to continue?`,
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: "Ok",
              cancelButtonText: "Cancel",
              customClass: {
                cancelButton: 'order-1 mr-3',
                confirmButton: 'btn btn-danger order-2',
              },
            }).then(result => {
              if (result.isConfirmed) {
                this.confirmUserStatus(data)
              }
            });
        } else {
          this.confirmUserStatus(data)
        }
        
      },

      confirmUserStatus(data) {
        otaDashboardService.disableUser(data).then(async (res) => {
          if(res && res.data.status) {
            this.getUsersList_API();
          } else {
            this.$toast.error(res.data.error_string)
          }
        })
        .catch(err => {
          console.log(err)
        })
      },

      reloadUserList() {
        this.getUsersList_API();
      },

      validateIPaddress(ip) {
        if (ip === '' || ip === undefined) {
          return true
        } else {
          if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip)){
            return true
          } else {
            return false
          }
        }
        
      }
    },

    computed: {
      noAccess() {
        // Determine access based on menu link configuration
        let userRoles = initService.getUserRoles();
        let link = this.$store.getters["getLinkByLink"](this.$router.currentRoute.path);

        if (!link) {
          return true;
        } else {
          userRoles = userRoles.filter(role => link.roles.includes(role.toUpperCase()));
          return userRoles.length === 0;
        }
      },
      lowRangeLength() {
        return this.start.length > 15;
      }, highRangeLength() {
        return this.end.length > 15;
      },
      usernameStatus() {
        let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        if (this.newUser.user_name && !format.test(this.newUser.user_name)) {
          return (this.newUser.user_name.length > 0 && !this.newUser.user_name.includes(' '));
        } else {
          return false
        }
      },
      passwordStatus() {
        return !!(this.passwordLength && this.passwordUppercase && this.passwordNumber && this.passwordCharacter);
      },
      passwordLength() {
        return this.newUser.password.length > 9
      },
      passwordUppercase() {
        let pass = this.newUser.password;
        for (let i = 0; i < pass.length; i++) {
          if ('A' <= pass[i] && pass[i] <= 'Z') {
            return true;
          }
        }
      },
      passwordNumber() {
        let pass = this.newUser.password;
        for (let i = 0; i < pass.length; i++) {
          if ('0' <= pass[i] && pass[i] <= '9') {
            return true;
          }
        }
      },
      passwordCharacter() {
        let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
        if (format.test(this.newUser.password)) {
          return true
        }
      },
      repeatPasswordCheck() {
        if (this.passwordStatus) {
          if (this.newUser.password === this.newUser.repeat_password) {
            return true;
          } else {
            return false
          }
        } else {
          return false
        }
      },
      
    }
  };
  
  </script>